<template>
  <div class="shop-block">
    <div class="title-wrap clearfix">
      <!-- <div :class="['tag', getTypeClass(shopCategory)]">
        {{ categoryName }}
      </div> -->
      <div class="type" :class="[getTypeClass(shopCategory)]">
        {{ shopCategory | typeName }}
      </div>
      <div class="title ellipsis">{{ shopName }}</div>
      <!-- <div class="guide" @click="goMap">
        <img :src="IconGuide" alt="" />
        查看地图
      </div> -->
    </div>
    <!-- <a class="info-item address" href="#/map" target="_blank">
      <SvgIcon class="icon" iconClass="ima-icon-location-fill" />
      {{ address }}
    </a> -->
    <div class="info-item address" @click="goMap">
      <!-- <SvgIcon class="icon" iconClass="ima-icon-location-fill" /> -->
      <img :src="IconLocation" alt="" class="icon">
      {{ address }}
    </div>
    <div class="info-item">
      <!-- <SvgIcon class="icon" iconClass="ima-icon-clock-circle-fill" /> -->
      <img :src="IconClock" alt="" class="icon">
      {{ businessHours }}
    </div>
    <div class="info-item">
      <!-- <SvgIcon class="icon" iconClass="ima-icon-telephone-fill" /> -->
      <img :src="IconTel" alt="" class="icon">
      {{ phone }}
    </div>
    <div class="info-item">
      <!-- <SvgIcon class="icon" iconClass="ima-icon-telephone-fill" /> -->
      <img :src="IconKey" alt="" class="icon">
      授权码{{ shopNo }}
    </div>
    <div v-if="!!tags.length" class="tags">
      <div v-for="tag in tags" :key="tag" class="tag">{{ tag }}</div>
    </div>
  </div>
</template>

<script>
import IconLocation from '@/assets/images/icon-location.png'
import IconClock from '@/assets/images/icon-clock.png'
import IconTel from '@/assets/images/icon-tel.png'
import IconKey from '@/assets/images/icon-key.png'
import IconGuide from '@/assets/images/icon-guide.png'

const typeMap = {
  1: {
    name: '直营店',
    color: '#ff3232',
    className: 'c1',
  },
  2: {
    name: '专卖店',
    color: '#398aff',
    className: 'c2',
  },
  3: {
    name: '专柜店',
    color: '#f90',
    className: 'c3',
  },
};
export default {
  name: 'ShopBlock',

  props: {
    shopName: {
      type: String,
    },
    categoryName: {
      type: String,
    },
    address: {
      type: String,
    },
    phone: {
      type: String,
    },
    businessHours: {
      type: String,
    },
    shopCategory: {
      type: Number,
    },
    distance: {
      type: String,
    },
    shopNo: {
      type: String,
    },
    shopTag: {
      type: String,
    },
  },

  data() {
    return {
      IconLocation,
      IconClock,
      IconTel,
      IconKey,
      IconGuide,
    };
  },

  computed: {
    tags() {
      const shopTag = this.shopTag || ''
      return !shopTag ? [] : shopTag.split(',')
    }
  },

  filters: {
    typeName(type) {
      return typeMap[type].name;
    },
  },

  methods: {
    getTypeClass(type) {
      return typeMap[type].className;
    },
    goMap() {
      // 地图调起API http://lbsyun.baidu.com/index.php?title=uri/api/web
      // const { longitude, latitude } = this.$attrs;
      // if (longitude && latitude) {
      //   // 有经纬度，使用百度地图调起API 2.1.3 反向地址解析
      //   const pos = `${latitude},${longitude}`;
      //   const url = `http://api.map.baidu.com/geocoder?location=${pos}&coord_type=bd09ll&output=html&src=webapp.baidu.openAPIdemo`;
      //   window.open(url, '_blank');
      // } else {
      //   // 没有经纬度，使用百度地图调起API 2.1.2 地址解析
      //   const address = this.address;
      //   const url = `http://api.map.baidu.com/geocoder?address=${address}&output=html&src=webapp.baidu.openAPIdemo`
      //   window.open(url, '_blank');
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.shop-block {
  box-sizing: border-box;
  width: 588px;
  // height: 234px;
  padding: 24px;
  border-radius: 4px;
  background: #fafafa;
  margin-bottom: 24px;
  &:nth-child(odd) {
    margin-right: 24px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
    line-height: 22px;
    margin-bottom: 16px;
    .type {
      margin-right: 8px;
      padding: 0 4px;
      line-height: 22px;
      font-size: 12px;
      border-radius: 4px;
      // background-color: #F34141;
      color: #fff;
      &.c1 {
        background-color: #ff3232;
      }
      &.c2 {
        background-color: #398aff;
      }
      &.c3 {
        background-color: #f90;
      }
    }
    .title {
      width: 384px;
      font-size: 16px;
      color: #323233;
      font-weight: bold;
    }
    .guide {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #7F7F7F;
      margin-left: auto;
      cursor: pointer;
      img {
        margin-right: 2px;
        margin-bottom: 2px;
        width: 17px;
        height: 17px;
      }
    }
    // .tag {
    //   float: right;
    //   font-size: 12px;
    //   border: 1px solid;
    //   border-radius: 4px;
    //   padding: 0 5px;
    //   line-height: 18px;
    //   margin: 7px 0 7px 5px;
    //   &.c1 {
    //     color: #ff3232;
    //     border-color: #ff3232;
    //   }
    //   &.c2 {
    //     color: #398aff;
    //     border-color: #398aff;
    //   }
    //   &.c3 {
    //     color: #f90;
    //     border-color: #f90;
    //   }
    // }
  }
  .info-item {
    display: flex;
    align-items: center;
    height: 20px;
    font-size: 14px;
    color: #7F7F7F;
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    &.address {
      //cursor: pointer;
      //&:hover {
      //  text-decoration: underline;
      //  color: #398aff;
      //}
    }
    .icon {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
  }
  .tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: -2px;
    .tag {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 8px;
      height: 24px;
      border-radius: 4px;
      min-width: 72px;
      margin-right: 16px;
      margin-top: 10px;
      border: 1px solid #F34141;
      color: #F34141;
      font-size: 14px;
    }
  }
}
</style>
